import React, { Component } from 'react'
import Swal from 'sweetalert2'
import Constant from '../../../Constant?.js'
import axios from 'axios'
import Moment from 'react-moment'
import moment from 'moment'
import { WaveLoading } from 'react-loadingg'

import html2canvas from 'html2canvas'
import { jsPDF } from 'jspdf'

import 'react-responsive-modal/styles.css'
import { Modal } from 'react-responsive-modal'
import EditChaletBooking from './EditChaletBooking.js'
import { convertTo12HourFormat } from '../../../common/Utils.js'
import { getCountryTimeZone, getCurrency, getVat } from '../../../Constant.js'
import RefundModel from '../../Booking/Refund.js'
import CheckPermission from '../../../common/Permissions/CheckPermission.js'
import { Link } from 'react-router-dom'
import SendPayment from '../../Booking/SendPayment.js'
import ComplaintModel from '../../Booking/Complaint.js'
import ComplaintActionModel from '../../Booking/ComplaintAction.js'
import Button from '../../../common/CustomComponents/Button.js'

class ChaletBookingDetail extends Component {
  state = {
    bookingData: null,
    refundModel: false,
    refunded_amount: 0,

    currency: getCurrency('KWT'),
    country: 'KWT',
    isLoading: false,

    note: '',

    editBookingDetailsModel: false,

    diwaniya_total_price: 0,
    waves_market_total_price: 0,
    store_total_price: 0,
    catering_total_price: 0,
    delivery_total_price: 0,

    cruise_img_base64: null,
    addOn_id: null,
    showItem: false,
    chaletList: [],

    // these keys are for download ticket for stores only
    shop_id: '',
    shop_type: '',
    shop_total_amount: '',
    shop_delivary_amount: '',
    shop_vat_amount: '',

    stores_booking: [],
    waves_market_booking: [],
    catering_booking: [],
    sendPaymentModel: false,
    complaintModel: false,
    complaintActionModel: false,
  }

  style = {
    tableData: {
      padding: 5,
      paddingLeft: 10,
      border: '1px solid #ddd',
    },
    tableDataUnpaid: {
      background: '#f77',
      color: '#fff',
      fontWeight: 'bold',
    },
    tableDataPaid: {
      background: '#eee',
    },
    cateringCell: {
      paddingLeft: 10,
      paddingTop: 8,
      paddingBottom: 5,
      background: '#999',
    },
  }

  componentDidMount() {
    this.getBookingDetails()
    this.getChaletList()
  }

  imageUrlToBase64 = async (imageUrl) => {
    try {
      const response = await fetch(imageUrl)
      const blob = await response.blob()

      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })
    } catch (error) {
      console.error('Error fetching or converting image:', error) // eslint-disable-line no-console
      return null
    }
  }

  getBookingDetails = async () => {
    await axios
      .get(Constant?.getAPI() + '/chalet/booking-details/' + this.props?.match?.params?.booking_id, {
        headers: {
          Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState(
            {
              bookingData: res?.data?.data,
              currency: getCurrency(res?.data?.data?.country),
              country: res?.data?.data?.country,
            },
            async () => {
              // diwaniya_items total
              if (this.state?.bookingData?.diwaniya_items?.length > 0) {
                let total = 0
                this.state?.bookingData?.diwaniya_items?.forEach((element) => {
                  total = total + element.item_qty * element.amount
                })

                this.setState({
                  diwaniya_total_price: total,
                })
              }

              // Waves Market Total
              // Store Total
              // Delivery charge Total
              if (this.state?.bookingData?.additional_items?.length > 0) {
                let waves_market_total_price = 0
                let store_total_price = 0
                let catering_total_price = 0
                let delivery_total_price = 0

                let differ_store_ids = []

                this.state?.bookingData?.additional_items?.forEach((element) => {
                  if (element?.store_item?.store?.shop_type == 'FOOD') {
                    waves_market_total_price = waves_market_total_price + element.item_qty * element.amount
                  } else if (element?.store_item?.store?.shop_type == 'STORE') {
                    store_total_price = store_total_price + element.item_qty * element.amount
                  } else if (element?.store_item?.store?.shop_type == 'CATERING') {
                    catering_total_price = catering_total_price + element.amount + element.addons_amount
                  }

                  if (!differ_store_ids.includes(element?.store_item?.store?.id)) {
                    differ_store_ids.push(element?.store_item?.store?.id)
                    delivery_total_price = delivery_total_price + element.delivery_charge
                  }
                })

                this.setState({
                  waves_market_total_price,
                  store_total_price,
                  catering_total_price,
                  delivery_total_price,
                  waves_market_booking: [
                    ...new Set(
                      this.state?.bookingData?.additional_items
                        .filter((item) => item?.payment_status == true && item?.store_item?.store?.shop_type == 'FOOD')
                        .map((item) =>
                          JSON.stringify({
                            id: item?.store_item?.store?.id,
                            category: item?.store_item?.store?.shop_name_en,
                          })
                        )
                    ),
                  ].map((item) => JSON.parse(item)),
                  stores_booking: [
                    ...new Set(
                      this.state?.bookingData?.additional_items
                        .filter((item) => item?.payment_status == true && item?.store_item?.store?.shop_type == 'STORE')
                        .map((item) =>
                          JSON.stringify({
                            id: item?.store_item?.store?.id,
                            category: item?.store_item?.store?.shop_name_en,
                          })
                        )
                    ),
                  ].map((item) => JSON.parse(item)),
                  catering_booking: [
                    ...new Set(
                      this.state?.bookingData?.additional_items
                        .filter(
                          (item) => item?.payment_status == true && item?.store_item?.store?.shop_type == 'CATERING'
                        )
                        .map((item) =>
                          JSON.stringify({
                            id: item?.store_item?.store?.id,
                            category: item?.store_item?.store?.shop_name_en,
                          })
                        )
                    ),
                  ].map((item) => JSON.parse(item)),
                })
              }

              let cruise_img_base64 = await this.imageUrlToBase64(
                Constant.getImage() + this.state.bookingData?.chalet?.img
              )

              this.setState({ cruise_img_base64 })

              let refudedAmount = this.state.bookingData?.account_refund

              if (this.state.bookingData?.customer?.wallet?.length > 0) {
                refudedAmount += this.state.bookingData?.customer?.wallet?.reduce((acc, ele) => {
                  return acc + ele.amount
                }, 0)
              }

              this.setState({
                refunded_amount: refudedAmount,
              })
            }
          )
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  showDetails = (type) => {
    switch (type) {
      case 'payment':
        var content
        if (this.state?.bookingData?.payment_details.length > 0) {
          content = `<div><table style="width:100%">
						<tbody>
							<tr>
							<th></th>
							${this.state?.bookingData?.payment_details.map((item, index) => `<th style="text-align: left">Payment ${index + 1}</th>`)}
							</tr>
							<tr>
							<th>Payment ID</th>
							${this.state?.bookingData?.payment_details.map((item) => `<td style="text-align: left">${item.payment_id || '--'}</td>`)}
							</tr>
							<tr>
							<th>Payment Status</th>
							${this.state?.bookingData?.payment_details
              .map(
                (item) =>
                  `<td style="text-align: left">
										${item.payment_status || '--'}
										${(item.payment_status === 'INITIATED' ||
                    item.payment_status === 'FAILED' ||
                    item.payment_status === 'PENDING') &&
                    item.payment_method_Id === 1
                    ? `<i 
													class="icofont icofont-refresh" 
													onclick="window.syncChaletPaymentHandler('${item.id}')" 
													style="margin-left: 10px; cursor: pointer; color: #007bff; font-size: 18px;" 
													title="Sync Payment">
												</i>`
                    : ''
                  }
									</td>`
              )
              .join('')}
							</tr>
							<tr>
							<th>Payment Method</th>
							${this.state?.bookingData?.payment_details.map((item) => '<td style="text-align: left">' + (item?.payment_method?.PaymentMethod_en || '--') + '</td>')}
							</tr>
              <tr>
                <th>Payment Amount</th>
                ${this.state?.bookingData?.payment_details
              .map(
                (item) => `
                  <td style="text-align: left; ${item.payment_amount < 0 ? 'background-color: red; color: white;' : ''}">
                    ${item.payment_currency || this.state.currency} ${item.payment_amount}
                  </td>
                `
              )
              .join('')}
              </tr>
							<tr>
							<th>Transaction ID</th>
							${this.state?.bookingData?.payment_details.map((item) => '<td style="text-align: left">' + (item.txn_id || '--') + '</td>')}
							</tr>
							<tr>
							<th>Invoice Reference ID</th>
							${this.state?.bookingData?.payment_details.map((item) => '<td style="text-align: left">' + (item.payment_info.InvoiceReference || '--') + '</td>')}
							</tr>
							<tr>
							<th>Payment Created at</th>
							${this.state?.bookingData?.payment_details.map((item) => '<td style="text-align: left">' + (item.createdAt ? moment(item.createdAt).format('YYYY-MM-DD HH:mm') : '--') + '</td>')}
							</tr>
						</tbody>
						</table>
						</div>
					`

          // Attach sync payment handler to window for button onclick
          window.syncChaletPaymentHandler = (paymentId) => {
            this.syncPayment(paymentId)
          }

          Swal.fire({
            width: '1000px',
            title: '<strong>Payment Details</strong>',
            html: content,
          })
        } else {
          Swal.fire({
            title: '<strong>Payment Details Not Found</strong>',
            icon: 'error',
            type: 'error',
          })
        }
        break
      default:
        break
    }
  }

  changeBookingDetails = async (state) => {
    if (moment(state?.start_date).format('YYYY-MM-DD') >= moment(state?.end_date).format('YYYY-MM-DD')) {
      Swal.fire('Error', `Start date should be less than end date`, 'error')
      return
    }

    this.setState({
      editBookingDetailsModel: false,
      isLoading: true,
    })

    let data = {
      booking_id: this.state?.bookingData?.id,
    }

    if (state?.type_tag && state?.type_tag != this.state.bookingData.type_tag) {
      data.type_tag = state?.type_tag
    }

    if (state?.booking_status && state?.booking_status != this.state.bookingData.booking_status) {
      data.booking_status = state?.booking_status
    }

    if (state?.selected_chalet_id && state?.selected_chalet_id != this.state.bookingData?.chalet?.id) {
      data.chalet_id = state?.selected_chalet_id
    }

    if (state?.start_date && moment(state?.start_date).format('YYYY-MM-DD') != this.state.bookingData?.start_date) {
      data.start_date = moment(state?.start_date).format('YYYY-MM-DD')
    }

    if (state?.end_date && moment(state?.end_date).format('YYYY-MM-DD') != this.state.bookingData?.end_date) {
      data.end_date = moment(state?.end_date).format('YYYY-MM-DD')
    }

    if (state?.chalet_amount && state?.chalet_amount != this.state.bookingData?.chalet_amount) {
      data.chalet_amount = state?.chalet_amount
    }

    if (state?.total_booking_amount && state?.total_booking_amount != this.state.bookingData?.total_booking_amount) {
      data.total_booking_amount = state?.total_booking_amount
    }

    await axios
      .post(Constant?.getAPI() + `/chalet/change-booking-details`, data, {
        headers: {
          Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          Swal.fire('Updated !', '', 'success')
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.getBookingDetails()

        this.setState({
          isLoading: false,
        })
      })
  }

  updateNote = async () => {
    if (this.state?.note?.length > 0) {
      const data = {
        booking_id: this.state.bookingData.id,
        comment: this.state.note,
      }

      await axios
        .post(Constant.getAPI() + '/chalet/update-note', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            Swal.fire('Updated !', 'Note Updated', 'success')
            this.getBookingDetails()
            this.setState({
              note: '',
            })
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  handleChange = (event) => {
    event.preventDefault()
    this.setState({ [event.target.name]: event.target.value })
  }

  downloadTicket = async (type, order_number) => {
    const scaleFactor = 2
    let ticketBlock = document.querySelector('#booking-ticket-capture')
    ticketBlock.style.display = 'unset'
    ticketBlock.style.width *= scaleFactor
    let can_adjust = true
    let imgData

    function checkDimentions(width, height, a4Width = 210, a4Height = 297) {
      const aspectRatio = width / height
      const maxWidth = a4Width
      const maxHeight = maxWidth / aspectRatio
      return maxWidth <= a4Width && maxHeight <= a4Height
    }

    await html2canvas(ticketBlock, { scale: scaleFactor }).then(async (canvas) => {
      can_adjust = checkDimentions(canvas.width, canvas.height)
      imgData = canvas.toDataURL('image/jpeg')
      ticketBlock.style.display = 'none'
      ticketBlock.style.width /= scaleFactor
    })

    if (type == 'pdf') {
      var pdf = new jsPDF()
      pdf.addImage(imgData, 'JPEG', 0, 0, can_adjust ? 210 : 0, can_adjust ? 0 : 297)

      pdf.save(`cruise-booking-${order_number}.pdf`)
    } else if (type == 'image') {
      const downloadLink = document.createElement('a')
      downloadLink.href = imgData
      downloadLink.download = `chalet-booking-${order_number}.jpeg`

      downloadLink.click()
    }
  }

  getBookingShareLink = async (number, code, order_number, user_type) => {
    const scaleFactor = 2
    let ticketBlock = document.querySelector('#booking-ticket-capture')
    ticketBlock.style.display = 'unset'
    ticketBlock.style.width *= scaleFactor
    this.setState({
      whatsAppShare: user_type,
    })

    html2canvas(ticketBlock, { scale: scaleFactor }).then(async (canvas) => {
      var imgData = canvas.toDataURL('image/jpeg', 1.0)

      var pdf = new jsPDF()
      pdf.addImage(imgData, 'JPEG', 0, 0, 0, 297)

      const pdfName = `chalet-booking-${order_number}.pdf`
      let pdfData = pdf.output('blob')

      const formData = new FormData()
      formData.append('pdfData', pdfData, pdfName)
      formData.append('pdfName', pdfName)

      await axios
        .post(Constant?.getAPI() + '/booking/save-booking-detail-pdf', formData, {
          headers: {
            Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          if (res?.data?.success) {
            let phoneNumber = code + number
            phoneNumber.replace(/\+/g, '')

            let text = ''
            if (user_type == 'captain') {
              text = `Dear Partner,\nYou have a new booking, please find the following link:\n${Constant.getImage()}/public/booking/chalet-booking-${order_number}.pdf`
            } else if (user_type == 'user') {
              text = `Dear User,\nThank you for booking with Waves! We are pleased to confirm your Booking.\nPlease find your booking confirmation by clicking on the following link:\n${Constant.getImage()}/public/booking/chalet-booking-${order_number}.pdf`
            }

            text = encodeURIComponent(text)

            window.open(`whatsapp://send?phone=${phoneNumber}&text=${text}`)
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
        .finally(() => {
          ticketBlock.style.display = 'none'
          this.setState({
            whatsAppShare: null,
          })
        })
    })
  }

  showCateringItems = (id) => {
    this.setState({
      addOn_id: id,
      showItem: true,
    })
  }

  processRefund = async (state) => {
    if (!state?.refund_type) {
      Swal.fire('Refund Type Required!', '', 'error')
      return
    }
    this.setState({
      refundModel: false,
    })
    const data = {
      booking_id: this.state.bookingData.id,
      refund_type: state?.refund_type,
      refund_amount: state?.refund_amount,
      comment_en: `Amount of ${state?.refund_amount} refunded to ${state?.refund_type} - ${state?.comment_en}`,
      comment_ar: `كمية ${state?.refund_amount} ردها إلى ${state?.refund_type} - ${state?.comment_ar}`,
    }
    await axios
      .post(Constant.getAPI() + '/chalet/chalet-refund', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Success !', 'Refund Processed', 'success')
          this.getBookingDetails()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getChaletList = async () => {
    var that = this

    const data = {}

    await axios
      .post(Constant.getAPI() + '/chalet/get-chalet-list', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            chaletList: res.data.data?.chalets,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getDownloadTicketButtons = (store_type) => {
    return (
      <>
        {this.state?.[
          store_type == 'STORE' ? 'stores_booking' : store_type == 'FOOD' ? 'waves_market_booking' : 'catering_booking'
        ]?.map((item) => (
          <button
            key={item.id}
            className="btn m-t-5"
            style={{ width: '100%', overflow: 'hidden' }}
            onClick={() => this.calcStoreDetailsDownloadTicket(item, store_type)}
          >
            <i className="icofont icofont-download m-r-5"></i> {item.category} Ticket
          </button>
        ))}
      </>
    )
  }

  calcStoreDetailsDownloadTicket = (item, store_type) => {
    this.setState({
      isLoading: true,
    })

    let storItems = []

    if (this.state?.bookingData?.additional_items?.length > 0) {
      this.state?.bookingData?.additional_items.forEach((itm) => {
        if (itm.store_item.store.id == item.id) {
          storItems.push(itm)
        }
      })
    }

    let shop_total_amount = 0
    let shop_delivary_amount = storItems[0].delivery_charge || 0
    let shop_vat_amount = 0

    storItems.forEach((itm) => {
      if (store_type === 'CATERING') {
        const extraPersonsCost = itm.additional_persons * (itm.store_item.person_price || 0)
        shop_total_amount = extraPersonsCost + itm.total_amount
      } else {
        shop_total_amount = shop_total_amount + itm.amount * itm.item_qty
      }
    })

    shop_vat_amount = ((shop_total_amount + shop_delivary_amount) * getVat(this.state.country)) / 100

    this.setState(
      {
        shop_id: item.id,
        shop_type: store_type,
        shop_total_amount: shop_total_amount + shop_delivary_amount + shop_vat_amount,
        shop_delivary_amount: shop_delivary_amount,
        shop_vat_amount: shop_vat_amount,
      },
      async () => {
        await this.downloadTicket('image', this.state.bookingData.order_number)
        setTimeout(() => {
          this.setState({
            shop_id: '',
            shop_type: '',
            shop_total_amount: '',
            shop_delivary_amount: '',
            shop_vat_amount: '',
          })
        }, 2000)
      }
    )

    this.setState({
      isLoading: false,
    })
  }

  sendPayment = async (state) => {
    if (!state?.amount) {
      Swal.fire('Amount Required!', '', 'error')
      return
    }

    this.setState({
      sendPaymentModel: false,
      isLoading: true,
    })

    const data = {
      booking_id: this.state.bookingData.id,
      amount: state?.amount,
    }

    await axios
      .post(Constant.getAPI() + '/chalet/send-payment', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Success !', 'Request send successfully', 'success')
          this.getBookingDetails()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  postComplaint = async (state) => {
    if (!state?.title) {
      Swal.fire('Title is Required!', '', 'error')
      return
    }
    if (!state?.description) {
      Swal.fire('Description is Required!', '', 'error')
      return
    }

    this.setState({
      complaintModel: false,
      isLoading: true,
    })

    const data = {
      booking_id: this.state.bookingData.id,
      title: state?.title,
      description: state?.description,
      type: 'CH',
    }

    await axios
      .post(Constant.getAPI() + '/admin/post-complaint', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Success !', 'Complaint raised successfully', 'success')
          this.getBookingDetails()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  syncPayment = async (paymentId) => {
    if (!paymentId) {
      Swal.fire({
        title: 'Payment ID is required',
        icon: 'error',
        type: 'error',
      })
      return
    }

    Swal.fire({
      title: 'Syncing Payment...',
      text: 'Please wait while we sync the payment status',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      },
    })

    await axios
      .get(Constant.getAPI() + `/admin/sync-chalet-payment/${paymentId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(() => {
        this.getBookingDetails()
        Swal.fire('Success', 'Payment synced successfully', 'success')
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            type: 'error',
          })
        }
      })
  }

  handleComplaintAction = (complaintId) => {
    this.setState({ complaintActionModel: true, selectedComplaintId: complaintId })
  }

  postAction = async (state) => {
    if (!state?.action) {
      Swal.fire('Action is Required!', '', 'error')
      return
    }
    if (!state?.note) {
      Swal.fire('Note is Required!', '', 'error')
      return
    }

    this.setState({
      complaintActionModel: false,
      isLoading: true,
    })

    const data = {
      complaint_id: this.state.selectedComplaintId,
      action: state?.action,
      note: state?.note,
      type: 'CH',
    }

    await axios
      .post(Constant.getAPI() + '/admin/post-complaint-action', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Success !', 'Complaint updated successfully', 'success')
          this.getBookingDetails()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  handleStatusChange = async (id, status) => {
    const data = {
      complaint_id: id,
      status: status,
      type: 'CH',
    }

    await axios
      .post(Constant.getAPI() + '/admin/update-complaint', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Success !', 'Status updated successfully', 'success')
          this.getBookingDetails()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    return (
      <div className="pcoded-inner-content">
        {this.state.isLoading == true && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              right: 0,
              width: '100%',
              height: '100%',
              background: 'rgba(0,0,0,0.5)',
              zIndex: 10000,
            }}
            onClick={(e) => {
              e.preventDefault()
            }}
          >
            <WaveLoading />
          </div>
        )}
        <Modal
          open={this.state.editBookingDetailsModel}
          onClose={() => {
            this.setState({ editBookingDetailsModel: false })
          }}
          center
        >
          <EditChaletBooking
            bookingDetails={this.state.bookingData}
            editBookingCruise={this.changeBookingDetails}
            chaletList={this.state.chaletList}
          ></EditChaletBooking>
        </Modal>
        <Modal
          open={this.state.refundModel}
          onClose={() => {
            this.setState({ refundModel: false })
          }}
          center
        >
          <RefundModel
            refundAmount={
              this.state?.bookingData?.total_booking_amount +
              this.state?.bookingData?.wallet_applied_amount -
              this.state?.refunded_amount || '0'
            }
            processRefund={this.processRefund}
          ></RefundModel>
        </Modal>
        <Modal
          open={this.state.sendPaymentModel}
          onClose={() => {
            this.setState({ sendPaymentModel: false })
          }}
          center
        >
          <SendPayment sendPayment={this.sendPayment}></SendPayment>
        </Modal>
        <Modal
          open={this.state.complaintModel}
          onClose={() => {
            this.setState({ complaintModel: false })
          }}
          center
        >
          <ComplaintModel
            postComplaint={this.postComplaint}
            type={'CH'}
          ></ComplaintModel>
        </Modal>
        <Modal
          open={this.state.complaintActionModel}
          onClose={() => {
            this.setState({ complaintActionModel: false })
          }}
          center
        >
          <ComplaintActionModel
            postAction={this.postAction}
            type={'CH'}
          ></ComplaintActionModel>
        </Modal>
        <div className="main-body">
          <div className="page-wrapper">
            <div
              className="page-header"
              id="store-order-header"
            >
              <div className="row align-items-end">
                <div className="col-3">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Chalet Booking Details</h4>
                    </div>
                  </div>
                </div>
                {this.state?.bookingData && (
                  <div className="col-9">
                    <Button
                      className="btn btn-sm btn-inverse f-right m-l-5"
                      onClick={() => {
                        this.setState(
                          {
                            shop_id: '',
                            shop_type: '',
                            shop_total_amount: '',
                            shop_delivary_amount: '',
                            shop_vat_amount: '',
                          },
                          () => {
                            this.downloadTicket('pdf', this.state.bookingData.order_number)
                          }
                        )
                      }}
                    >
                      <i className="icofont icofont-download m-r-5"></i> Ticket PDF
                    </Button>
                    <Button
                      className="btn btn-sm btn-inverse f-right m-l-5"
                      onClick={() => {
                        this.setState(
                          {
                            shop_id: '',
                            shop_type: '',
                            shop_total_amount: '',
                            shop_delivary_amount: '',
                            shop_vat_amount: '',
                          },
                          () => {
                            this.downloadTicket('image', this.state.bookingData.order_number)
                          }
                        )
                      }}
                    >
                      <i className="icofont icofont-download m-r-5"></i> Ticket Image
                    </Button>
                    {localStorage.getItem('loged_In_role') === 'store' ? (
                      <></>
                    ) : (
                      <Button
                        className="btn btn-sm btn-inverse f-right m-l-5"
                        onClick={() => {
                          if (localStorage.getItem('countryShortName') != this.state.bookingData.country) {
                            Swal.fire(
                              '',
                              `Please change country to ${this.state.bookingData.country} for edit this booking details`,
                              'error'
                            )
                            return
                          }
                          this.setState({ editBookingDetailsModel: true })
                        }}
                      >
                        <i className="icofont icofont-ui-edit m-r-5"></i> Edit Booking
                      </Button>
                    )}
                    <CheckPermission permission={'refund-booking'}>
                      <Button
                        className="btn btn-sm btn-inverse f-right m-l-5"
                        onClick={() => {
                          this.setState({ refundModel: true })
                        }}
                        disabled={
                          this.state?.refunded_amount >=
                          this.state?.bookingData?.total_booking_amount + this.state?.bookingData?.wallet_applied_amount
                        }
                      >
                        <i className="icofont icofont-ui-rotation m-r-5"></i> Refund
                      </Button>
                    </CheckPermission>
                    <Button
                      className="btn btn-sm btn-inverse f-right m-l-5"
                      style={{ backgroundColor: '#5fcd85', color: '#000' }}
                      onClick={() => {
                        if (localStorage.getItem('countryShortName') != this.state.bookingData.country) {
                          Swal.fire(
                            '',
                            `Please change country to ${this.state.bookingData.country} for edit this booking details`,
                            'error'
                          )
                          return
                        }
                        this.setState({ sendPaymentModel: true })
                      }}
                    >
                      <i className="icofont icofont-card m-r-5"></i> Request Payment
                    </Button>
                    <Button
                      className="btn btn-sm btn-inverse f-right m-l-5"
                      style={{ backgroundColor: '#ee3a28', color: '#000' }}
                      onClick={() => {
                        if (localStorage.getItem('countryShortName') != this.state.bookingData.country) {
                          Swal.fire(
                            '',
                            `Please change country to ${this.state.bookingData.country} for edit this booking details`,
                            'error'
                          )
                          return
                        }
                        this.setState({ complaintModel: true })
                      }}
                    >
                      <i className="icofont icofont-contacts m-r-5"></i> Raise Complaint
                    </Button>
                  </div>
                )}
              </div>
            </div>
            <div
              className="page-body"
              id="store-order-details"
            >
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      {this.state?.bookingData ? (
                        <>
                          <div
                            className="row"
                            style={{ padding: 10, borderBottom: '1px solid #ddd' }}
                          >
                            <div
                              className="col-md-6 col-sm-12"
                              style={{ borderRight: '1px solid #ddd' }}
                            >
                              <div
                                className="row"
                                style={{ marginBottom: 10 }}
                              >
                                <div
                                  className="col-3"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Booking Details</div>
                                </div>
                                <div
                                  className="col-4"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Booking ID</div>
                                  <div>Booking Status</div>
                                  <div>Booking Type tag</div>
                                  <div>Booking Duration</div>
                                  <div>Issue date</div>
                                </div>
                                <div className="col-5">
                                  <div style={{ fontWeight: 'bolder' }}>
                                    {this.state.bookingData?.order_number || '--'}{' '}
                                    {this.state.bookingData?.from_flash_offer == true && (
                                      <img
                                        src={'./assets/images/ic_flash_icon.png'}
                                        alt="img"
                                        onError={(event) => {
                                          event.currentTarget.src = './assets/images/ic_flash_icon.png'
                                        }}
                                        style={{ height: 20 }}
                                      />
                                    )}
                                  </div>
                                  <div style={{ fontWeight: 'bolder', color: 'green' }}>
                                    {this.state?.bookingData?.booking_status == 'Cancelled' ? (
                                      <span className="badge badge-pill badge-warning">Cancelled</span>
                                    ) : this.state?.bookingData?.booking_status == 'Postponed' ? (
                                      <span className="badge badge-pill badge-warning">Postponed</span>
                                    ) : this.state?.bookingData?.booking_status == 'Confirmed' ? (
                                      <span className="badge badge-pill badge-success">Confirmed</span>
                                    ) : this.state?.bookingData?.booking_status == 'Successful' ? (
                                      <span className="badge badge-pill badge-success">Successful</span>
                                    ) : this.state?.bookingData?.booking_status == 'Pending' &&
                                      this.state?.bookingData?.payment_status == true ? (
                                      <span className="badge badge-pill badge-warning">In Progress</span>
                                    ) : (
                                      <span className="badge badge-pill badge-warning">In complete booking</span>
                                    )}
                                  </div>
                                  <div>{this.state?.bookingData?.type_tag || '--'}</div>
                                  <div>
                                    {this.state?.bookingData?.start_date
                                      ? moment(this.state?.bookingData?.start_date, 'YYYY-MM-DD').format('DD MMM YYYY')
                                      : ''}
                                    -
                                    {this.state?.bookingData?.end_date
                                      ? moment(this.state?.bookingData?.end_date, 'YYYY-MM-DD').format('DD MMM YYYY')
                                      : ''}
                                  </div>
                                  <div>
                                    <Moment format="DD MMM YYYY HH:mm:ss">{this.state?.bookingData?.createdAt}</Moment>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6 col-sm-12">
                              <div
                                className="row"
                                style={{ marginBottom: 10 }}
                              >
                                <div
                                  className="col-3"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>User Details</div>
                                </div>
                                <div
                                  className="col-4"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Customer Name</div>
                                  {localStorage.getItem('loged_In_role') === 'store' ? (
                                    <></>
                                  ) : (
                                    <div style={{ height: 50 }}>Profile</div>
                                  )}
                                  <div>Phone</div>
                                  {localStorage.getItem('loged_In_role') === 'store' ? <></> : <div>Email</div>}
                                  {localStorage.getItem('loged_In_role') === 'store' ? <></> : <div>Device Type</div>}
                                  {localStorage.getItem('loged_In_role') === 'store' ? <></> : <div>Device Name</div>}
                                </div>
                                <div className="col-5">
                                  <div style={{ textTransform: 'capitalize' }}>
                                    {!this.state?.bookingData?.customer?.first_name &&
                                      !this.state?.bookingData?.customer?.last_name &&
                                      this.state?.bookingData?.customer?.is_guest
                                      ? 'Guest User'
                                      : this.state?.bookingData?.customer?.first_name &&
                                        this.state?.bookingData?.customer?.last_name
                                        ? this.state?.bookingData?.customer?.first_name +
                                        ' ' +
                                        this.state?.bookingData?.customer?.last_name
                                        : '--'}
                                  </div>
                                  {localStorage.getItem('loged_In_role') === 'store' ? (
                                    <></>
                                  ) : (
                                    <div style={{ height: 50 }}>
                                      <img
                                        src={
                                          this.state?.bookingData?.customer?.user_profile &&
                                            typeof this.state?.bookingData?.customer?.user_profile == 'string'
                                            ? Constant.getImage() + this.state?.bookingData?.customer?.user_profile
                                            : './assets/images/no_image.png'
                                        }
                                        className="img-fluid"
                                        alt="img"
                                        onError={(event) => {
                                          event.currentTarget.src = './assets/images/no_image.png'
                                        }}
                                        style={{ height: 40, border: '1px solid #aaa', borderRadius: 5 }}
                                      />
                                    </div>
                                  )}
                                  <div>
                                    {!this.state?.bookingData?.customer?.country_code &&
                                      !this.state?.bookingData?.customer?.phone
                                      ? '--'
                                      : this.state?.bookingData?.customer?.country_code +
                                      ' ' +
                                      this.state?.bookingData?.customer?.phone}
                                    {this.state.whatsAppShare != 'user' ? (
                                      <span
                                        onClick={() =>
                                          this.getBookingShareLink(
                                            this.state.bookingData.customer.phone,
                                            this.state.bookingData.customer.country_code,
                                            this.state.bookingData.order_number,
                                            'user'
                                          )
                                        }
                                        title="Booking Detail Share"
                                      >
                                        <img
                                          className="img-fluid m-l-5"
                                          src="./assets/images/whatsapp.png"
                                          alt="ico"
                                          style={{ width: 20 }}
                                        />
                                      </span>
                                    ) : (
                                      <div style={{ marginLeft: 10 }}>
                                        <WaveLoading
                                          color="#46C655"
                                          size="small"
                                        />
                                      </div>
                                    )}
                                  </div>
                                  {localStorage.getItem('loged_In_role') === 'store' ? (
                                    <></>
                                  ) : (
                                    <div>
                                      {this.state?.bookingData?.customer?.is_guest &&
                                        !this.state?.bookingData?.customer?.email
                                        ? 'Guest User'
                                        : this.state?.bookingData?.customer?.email
                                          ? this.state?.bookingData?.customer?.email
                                          : '--'}
                                    </div>
                                  )}
                                  {localStorage.getItem('loged_In_role') === 'store' ? (
                                    <></>
                                  ) : (
                                    <div>
                                      {this.state?.bookingData?.device_type == 'W'
                                        ? 'Website'
                                        : this.state?.bookingData?.device_type || '--'}
                                    </div>
                                  )}
                                  {localStorage.getItem('loged_In_role') === 'store' ? (
                                    <></>
                                  ) : (
                                    <div>{this.state?.bookingData?.device_name || '--'}</div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="row"
                            style={{ padding: 10, borderBottom: '1px solid #ddd' }}
                          >
                            <div
                              className="col-md-6 col-sm-12"
                              style={{ borderRight: '1px solid #ddd' }}
                            >
                              <div
                                className="row"
                                style={{ marginBottom: 10 }}
                              >
                                <div
                                  className="col-3"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Chalet Details</div>
                                </div>
                                <div
                                  className="col-4"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Name</div>
                                  <div>Address</div>
                                  <div>Address Details</div>
                                  <div>Check in</div>
                                  <div>Check out</div>
                                </div>
                                <div className="col-5">
                                  <div>{this.state.bookingData?.chalet?.name_en || '--'}</div>
                                  <div>{this.state.bookingData?.chalet?.address_en || '--'}</div>
                                  <div>{this.state.bookingData?.chalet?.address_details_en || '--'}</div>
                                  <div>{this.state.bookingData?.chalet?.check_in_time || '--'}</div>
                                  <div>{this.state.bookingData?.chalet?.check_out_time || '--'}</div>
                                </div>
                              </div>
                              {localStorage.getItem('loged_In_role') === 'store' ? (
                                <></>
                              ) : (
                                <div
                                  className="row"
                                  style={{ marginBottom: 10 }}
                                >
                                  <div
                                    className="col-3"
                                    style={{ fontWeight: 'bold' }}
                                  >
                                    <div>Coupon Details</div>
                                  </div>
                                  <div
                                    className="col-4"
                                    style={{ fontWeight: 'bold' }}
                                  >
                                    <div>Coupon Code</div>
                                    <div>Coupon Type</div>
                                  </div>
                                  <div className="col-5">
                                    <div>
                                      {this.state?.bookingData?.coupon_id &&
                                        this.state?.bookingData?.coupon_type +
                                        ' - ' +
                                        (this.state?.bookingData?.coupon_type == 'BC'
                                          ? this.state?.bookingData?.bulkCoupon?.coupon_code || '--'
                                          : this.state?.bookingData?.coupon?.coupon_code || '--')}
                                    </div>
                                    <div>
                                      {this.state?.bookingData?.bulkCoupon?.coupon_type ||
                                        this.state?.bookingData?.coupon?.coupon_type ||
                                        '--'}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                            {localStorage.getItem('loged_In_role') === 'store' ? (
                              <></>
                            ) : (
                              <div className="col-md-6 col-sm-12">
                                <div
                                  className="row"
                                  style={{ marginBottom: 10 }}
                                >
                                  <div
                                    className="col-3"
                                    style={{ fontWeight: 'bold' }}
                                  >
                                    <div>Payment Details</div>
                                  </div>
                                  <div
                                    className="col-4"
                                    style={{ fontWeight: 'bold' }}
                                  >
                                    <div>
                                      Payment Status
                                      <img
                                        className="img-fluid m-l-5"
                                        src="./assets/images/info.png"
                                        alt="ico"
                                        style={{ width: 13 }}
                                        onClick={() => this.showDetails('payment')}
                                      />
                                    </div>
                                    <div>Total Amount</div>
                                  </div>
                                  <div className="col-5">
                                    <div>{this.state?.bookingData?.payment_status === true ? 'True' : 'False'}</div>
                                    <div>
                                      {this.state?.currency + ' ' + this.state?.bookingData?.total_booking_amount ||
                                        '0'}
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="row"
                                  style={{ marginBottom: 10 }}
                                >
                                  <div
                                    className="col-3"
                                    style={{ fontWeight: 'bold' }}
                                  >
                                    <div>Package Details</div>
                                  </div>
                                  <div
                                    className="col-4"
                                    style={{ fontWeight: 'bold' }}
                                  >
                                    <div>Name</div>
                                    <div>Duration</div>
                                    <div>Price</div>
                                  </div>
                                  <div className="col-5">
                                    <div>{this.state?.bookingData?.package?.name_en || '--'}</div>
                                    <div>
                                      {this.state?.bookingData?.package?.start_day}--
                                      {this.state?.bookingData?.package?.end_day}
                                    </div>
                                    <div>{this.state?.bookingData?.package?.price || '--'}</div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                          <div
                            className="row"
                            style={{ padding: 10 }}
                          >
                            <div className="col-12">
                              {localStorage.getItem('loged_In_role') === 'store' ? (
                                <></>
                              ) : (
                                <div className="row">
                                  <div
                                    className="col-2"
                                    style={{ fontWeight: 'bold' }}
                                  >
                                    Add-ons
                                  </div>
                                  <div className="col-10">
                                    <div className="row">
                                      <div className="col-sm-12">
                                        <div className="table-responsive">
                                          <table className="table">
                                            <tbody>
                                              <tr
                                                className="thead-inverse"
                                                style={{ height: 40 }}
                                              >
                                                <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                  Item Name
                                                </th>
                                                <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                  Category
                                                </th>
                                                <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                  Special Request
                                                </th>
                                                <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                  Payment status
                                                </th>
                                                <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                  Quantity
                                                </th>
                                                <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                  Delivery charge
                                                </th>
                                                <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                  Unit Price
                                                </th>
                                                <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                  Total
                                                </th>
                                                <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                  Delivary
                                                  <br />
                                                  Date & Time
                                                </th>
                                              </tr>
                                              {this.state?.bookingData?.diwaniya_items?.length > 0 &&
                                                this.state?.bookingData?.diwaniya_items.map((item) => (
                                                  <tr
                                                    key={item.id}
                                                    style={
                                                      item?.payment_status
                                                        ? this.style.tableDataPaid
                                                        : this.style.tableDataUnpaid
                                                    }
                                                  >
                                                    <td style={this.style.tableData}>
                                                      {item?.chalet_diwaniya?.item_name_en || '--'}
                                                    </td>
                                                    <td style={this.style.tableData}>
                                                      {item?.chalet_diwaniya?.category?.name_en || '--'}
                                                    </td>
                                                    <td style={this.style.tableData}>{item.notes || '--'}</td>
                                                    <td style={this.style.tableData}>
                                                      {item?.payment_status === true ? (
                                                        <span className="badge badge-success">Success</span>
                                                      ) : (
                                                        <span className="badge badge-danger">Pending</span>
                                                      )}
                                                    </td>
                                                    <td style={this.style.tableData}>{item.item_qty || '--'}</td>
                                                    <td style={this.style.tableData}>N/A</td>
                                                    <td style={this.style.tableData}>
                                                      {this.state?.currency + ' ' + item?.amount}
                                                    </td>
                                                    <td style={this.style.tableData}>
                                                      {this.state?.currency + ' ' + item?.amount * item.item_qty}
                                                    </td>
                                                    <td style={this.style.tableData}>
                                                      {item.delivery_date} -- {item.delivery_time}
                                                    </td>
                                                  </tr>
                                                ))}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}

                              <div className="row">
                                <div
                                  className="col-2"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  Waves Market
                                  {this.getDownloadTicketButtons('FOOD')}
                                </div>
                                <div className="col-10">
                                  <div className="row">
                                    <div className="col-sm-12">
                                      <div className="table-responsive">
                                        <table className="table">
                                          <tbody>
                                            <tr
                                              className="thead-inverse"
                                              style={{ height: 40 }}
                                            >
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Shop Name
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Item Name
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>SKU</th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Special Request
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Payment status
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Quantity
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Delivery charge
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Unit Price
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Total
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Delivary
                                                <br />
                                                Date & Time
                                              </th>
                                            </tr>
                                            {this.state?.bookingData?.additional_items?.length > 0 &&
                                              // eslint-disable-next-line
                                              this.state?.bookingData?.additional_items.map((item) => {
                                                if (item?.store_item?.store?.shop_type == 'FOOD') {
                                                  return (
                                                    <tr
                                                      key={item.id}
                                                      style={
                                                        item?.payment_status
                                                          ? this.style.tableDataPaid
                                                          : this.style.tableDataUnpaid
                                                      }
                                                    >
                                                      <td style={this.style.tableData}>
                                                        {item?.store_item?.store?.shop_name_en || '--'}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {item?.store_item?.item_name_en || '--'}
                                                        {item?.store_item_option?.name_en && (
                                                          <span className="text-danger">{`(${item.store_item_option.name_en})`}</span>
                                                        )}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {item?.store_item?.sku || '--'}
                                                      </td>
                                                      <td style={this.style.tableData}>{item?.notes || '--'}</td>
                                                      <td style={this.style.tableData}>
                                                        {item?.payment_status === true ? (
                                                          <span className="badge badge-success">Success</span>
                                                        ) : (
                                                          <span className="badge badge-danger">Pending</span>
                                                        )}
                                                      </td>
                                                      <td style={this.style.tableData}>{item.item_qty || '--'}</td>
                                                      <td style={this.style.tableData}>
                                                        {this.state?.currency + ' ' + (item.delivery_charge || '0')}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {this.state?.currency + ' ' + item?.amount}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {this.state?.currency + ' ' + item?.amount * item.item_qty}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {item.delivery_date} -- {item.delivery_time}
                                                      </td>
                                                    </tr>
                                                  )
                                                }
                                              })}
                                            {this.state?.bookingData?.bulkCoupon?.coupon_type == 'drink' && (
                                              <tr style={this.style.tableDataPaid}>
                                                <td
                                                  style={{
                                                    ...this.style.tableData,
                                                    color: 'green',
                                                    fontWeight: 'bold',
                                                  }}
                                                >
                                                  Free Drinks
                                                </td>
                                                <td style={this.style.tableData}>--</td>
                                                <td style={this.style.tableData}>--</td>
                                                <td style={this.style.tableData}>--</td>
                                                <td
                                                  style={{
                                                    ...this.style.tableData,
                                                    color: 'green',
                                                    fontWeight: 'bold',
                                                  }}
                                                >
                                                  {this.state?.bookingData?.bulkCoupon?.no_of_drinks || 0}
                                                </td>
                                                <td style={this.style.tableData}>--</td>
                                                <td style={this.style.tableData}>{this.state?.currency + ' 0'}</td>
                                                <td style={this.style.tableData}>{this.state?.currency + ' 0'}</td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div
                                  className="col-2"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  Stores
                                  {this.getDownloadTicketButtons('STORE')}
                                </div>
                                <div className="col-10">
                                  <div className="row">
                                    <div className="col-sm-12">
                                      <div className="table-responsive">
                                        <table className="table">
                                          <tbody>
                                            <tr
                                              className="thead-inverse"
                                              style={{ height: 40 }}
                                            >
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Shop Name
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Item Name
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>SKU</th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Special Request
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Payment status
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Quantity
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Delivery charge
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Unit Price
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Total
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Delivary
                                                <br />
                                                Date & Time
                                              </th>
                                            </tr>
                                            {this.state?.bookingData?.additional_items?.length > 0 &&
                                              // eslint-disable-next-line
                                              this.state?.bookingData?.additional_items.map((item) => {
                                                if (item?.store_item?.store?.shop_type == 'STORE') {
                                                  return (
                                                    <tr
                                                      key={item.id}
                                                      style={
                                                        item?.payment_status
                                                          ? this.style.tableDataPaid
                                                          : this.style.tableDataUnpaid
                                                      }
                                                    >
                                                      <td style={this.style.tableData}>
                                                        {item?.store_item?.store?.shop_name_en || '--'}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {item?.store_item?.item_name_en || '--'}
                                                        {item?.store_item_option?.name_en && (
                                                          <span className="text-danger">{`(${item.store_item_option.name_en})`}</span>
                                                        )}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {item?.store_item?.sku || '--'}
                                                      </td>
                                                      <td style={this.style.tableData}>{item?.notes || '--'}</td>
                                                      <td style={this.style.tableData}>
                                                        {item?.payment_status === true ? (
                                                          <span className="badge badge-success">Success</span>
                                                        ) : (
                                                          <span className="badge badge-danger">Pending</span>
                                                        )}
                                                      </td>
                                                      <td style={this.style.tableData}>{item.item_qty || '--'}</td>
                                                      <td style={this.style.tableData}>
                                                        {this.state?.currency + ' ' + (item.delivery_charge || '0')}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {this.state?.currency + ' ' + item?.amount}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {this.state?.currency + ' ' + item?.amount * item.item_qty}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {item.delivery_date} -- {item.delivery_time}
                                                      </td>
                                                    </tr>
                                                  )
                                                }
                                              })}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div
                                  className="col-2"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  Catering
                                  {this.getDownloadTicketButtons('CATERING')}
                                </div>
                                <div className="col-10">
                                  <div className="row">
                                    <div className="col-sm-12">
                                      <div className="table-responsive">
                                        <table className="table">
                                          <thead>
                                            <tr
                                              className="thead-inverse"
                                              style={{ height: 40 }}
                                            >
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Item Name
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Shop Name
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Special Request
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Payment status
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Quantity
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Delivery charge
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Unit Price
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Add Ons Price
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Total
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Delivery
                                                <br /> Date & Time
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {this.state?.bookingData?.additional_items?.length > 0 &&
                                              // eslint-disable-next-line
                                              this.state?.bookingData?.additional_items.map((item) => {
                                                if (item?.store_item?.store?.shop_type === 'CATERING') {
                                                  return (
                                                    <>
                                                      <tr
                                                        key={item.id}
                                                        style={
                                                          item?.payment_status
                                                            ? this.style.tableDataPaid
                                                            : this.style.tableDataUnpaid
                                                        }
                                                      >
                                                        <td style={this.style.tableData}>
                                                          {item?.store_item?.item_name_en || '--'}
                                                        </td>
                                                        <td style={this.style.tableData}>
                                                          {item?.store_item?.store?.shop_name_en || '--'}
                                                        </td>
                                                        <td style={this.style.tableData}>{item?.notes || '--'}</td>
                                                        <td style={this.style.tableData}>
                                                          {item?.payment_status === true ? (
                                                            <span className="badge badge-success">Success</span>
                                                          ) : (
                                                            <span className="badge badge-danger">Pending</span>
                                                          )}
                                                        </td>
                                                        <td style={this.style.tableData}>{item.item_qty || '--'}</td>
                                                        <td style={this.style.tableData}>
                                                          {this.state?.currency + ' ' + (item.delivery_charge || '0')}
                                                        </td>
                                                        <td style={this.style.tableData}>
                                                          {this.state?.currency + ' ' + item?.amount}
                                                        </td>
                                                        <td style={this.style.tableData}>
                                                          {this.state?.currency + ' ' + item?.addons_amount}
                                                        </td>
                                                        <td style={this.style.tableData}>
                                                          {this.state?.currency +
                                                            ' ' +
                                                            (item?.amount + item?.addons_amount)}
                                                        </td>
                                                        <td
                                                          style={this.style.tableData}
                                                        >{`${item.delivery_date} -- ${item.delivery_time}`}</td>
                                                      </tr>
                                                      {item?.catering_items?.length > 0 && (
                                                        <tr style={{ background: '#eee', border: '1px solid #ddd' }}>
                                                          <td
                                                            colSpan={10}
                                                            className=""
                                                          >
                                                            <table
                                                              key={item.id}
                                                              className="table"
                                                            >
                                                              <tbody>
                                                                <tr
                                                                  className="thead-inverse"
                                                                  style={{ height: 20, background: '#555' }}
                                                                >
                                                                  <th style={this.style.cateringCell}>Item Name</th>
                                                                  <th style={this.style.cateringCell}>Quantity</th>
                                                                  <th style={this.style.cateringCell}>Unit Price</th>
                                                                  <th style={this.style.cateringCell}>Total Price</th>
                                                                </tr>
                                                                {item?.catering_items.map((ele) => (
                                                                  <tr key={ele.id}>
                                                                    <td
                                                                      style={{
                                                                        ...this.style.tableData,
                                                                        background: '#eec',
                                                                      }}
                                                                    >
                                                                      {ele?.store_catering_item?.name_en || '--'}
                                                                    </td>
                                                                    <td
                                                                      style={{
                                                                        ...this.style.tableData,
                                                                        background: '#eec',
                                                                      }}
                                                                    >
                                                                      {ele.item_qty || '--'}
                                                                    </td>
                                                                    <td
                                                                      style={{
                                                                        ...this.style.tableData,
                                                                        background: '#eec',
                                                                      }}
                                                                    >
                                                                      {this.state?.currency +
                                                                        ' ' +
                                                                        (ele.is_addon ? ele?.amount : 0)}
                                                                    </td>
                                                                    <td
                                                                      style={{
                                                                        ...this.style.tableData,
                                                                        background: '#eec',
                                                                      }}
                                                                    >
                                                                      {this.state?.currency +
                                                                        ' ' +
                                                                        (ele.is_addon ? ele?.amount * ele.item_qty : 0)}
                                                                    </td>
                                                                  </tr>
                                                                ))}
                                                              </tbody>
                                                            </table>
                                                          </td>
                                                        </tr>
                                                      )}
                                                    </>
                                                  )
                                                }
                                              })}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div
                                className="row"
                                style={{ borderBottom: '1px solid #ddd' }}
                              >
                                <div
                                  className="col-6"
                                  style={{ fontWeight: 'bold' }}
                                ></div>
                                <div className="col-6">
                                  <div className="row">
                                    <div className="col-sm-12">
                                      <div className="table-responsive">
                                        <table className="table">
                                          <tbody>
                                            <tr
                                              className="thead-inverse"
                                              style={{ height: 40 }}
                                            >
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Description
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Price
                                              </th>
                                            </tr>
                                            {localStorage.getItem('loged_In_role') === 'store' ? (
                                              <></>
                                            ) : (
                                              <tr style={this.style.tableDataPaid}>
                                                <td style={this.style.tableData}>{'Chalet Price'}</td>
                                                <td style={this.style.tableData}>
                                                  {this.state?.currency} {this.state?.bookingData?.chalet_amount || '0'}
                                                </td>
                                              </tr>
                                            )}
                                            {localStorage.getItem('loged_In_role') === 'store' ? (
                                              <></>
                                            ) : (
                                              <tr style={this.style.tableDataPaid}>
                                                <td style={this.style.tableData}>{'Add-ons'}</td>
                                                <td style={this.style.tableData}>
                                                  {this.state?.currency} {this.state?.diwaniya_total_price || '0'}
                                                </td>
                                              </tr>
                                            )}
                                            <tr style={this.style.tableDataPaid}>
                                              <td style={this.style.tableData}>{'Waves Market'}</td>
                                              <td style={this.style.tableData}>
                                                {this.state?.currency} {this.state?.waves_market_total_price || '0'}
                                              </td>
                                            </tr>
                                            <tr style={this.style.tableDataPaid}>
                                              <td style={this.style.tableData}>{'Stores'}</td>
                                              <td style={this.style.tableData}>
                                                {this.state?.currency} {this.state?.store_total_price || '0'}
                                              </td>
                                            </tr>
                                            <tr style={this.style.tableDataPaid}>
                                              <td style={this.style.tableData}>{'Catering'}</td>
                                              <td style={this.style.tableData}>
                                                {this.state?.currency} {this.state?.catering_total_price || '0'}
                                              </td>
                                            </tr>
                                            <tr style={this.style.tableDataPaid}>
                                              <td style={this.style.tableData}>{'Delivery Charges'}</td>
                                              <td style={this.style.tableData}>
                                                {this.state?.currency} {this.state?.delivery_total_price || '0'}
                                              </td>
                                            </tr>
                                            <tr style={this.style.tableDataPaid}>
                                              <td style={this.style.tableData}>{'Vat'}</td>
                                              <td style={this.style.tableData}>
                                                {this.state?.currency}{' '}
                                                {this.state?.bookingData?.vat_amount || this.state?.vat_amount || '0'}
                                              </td>
                                            </tr>
                                            {localStorage.getItem('loged_In_role') === 'store' ? (
                                              <></>
                                            ) : (
                                              <>
                                                <tr style={this.style.tableDataPaid}>
                                                  <td style={this.style.tableData}>{'Discount Coupon'}</td>
                                                  <td style={{ ...this.style.tableData, color: 'red' }}>
                                                    {this.state?.currency}{' '}
                                                    {this.state?.bookingData?.coupon_applied_amount || '0'}
                                                  </td>
                                                </tr>
                                                <tr style={this.style.tableDataPaid}>
                                                  <td style={this.style.tableData}>
                                                    {'Wallet Amount Applied'}
                                                    {this.state?.bookingData?.wallet_applied_amount > 0 && (
                                                      <Link
                                                        to={
                                                          '/all-users/edit/user-wallet/' +
                                                          this.state?.bookingData?.customer?.id
                                                        }
                                                        className="m-r-15 text-muted"
                                                      >
                                                        <img
                                                          className="img-fluid m-l-5"
                                                          src="./assets/images/info.png"
                                                          alt="ico"
                                                          style={{ width: 13 }}
                                                        />
                                                      </Link>
                                                    )}
                                                  </td>
                                                  <td style={{ ...this.style.tableData, color: 'red' }}>
                                                    {this.state?.currency}{' '}
                                                    {this.state?.bookingData?.wallet_applied_amount || '0'}
                                                  </td>
                                                </tr>
                                                {this.state?.bookingData?.cost_of_service > 0 && <tr style={this.style.tableDataPaid}>
                                                  <td style={this.style.tableData}>{'Cost of Service'}</td>
                                                  <td style={this.style.tableData}>
                                                    {this.state?.currency} {this.state?.bookingData?.cost_of_service || '0'}
                                                  </td>
                                                </tr>}
                                                <tr style={this.style.tableDataPaid}>
                                                  <td style={{ ...this.style.tableData, fontWeight: 'bolder' }}>
                                                    {'Extra Payment'}
                                                  </td>
                                                  <td
                                                    style={{
                                                      ...this.style.tableData,
                                                      fontWeight: 'bolder',
                                                      color: '#0004ff',
                                                    }}
                                                  >
                                                    {this.state?.currency}{' '}
                                                    {this.state?.bookingData?.extra_payment || '0'}
                                                  </td>
                                                </tr>
                                                <tr style={this.style.tableDataPaid}>
                                                  <td style={{ ...this.style.tableData, fontWeight: 'bolder' }}>
                                                    {'Total Amount'}
                                                  </td>
                                                  <td style={{ ...this.style.tableData, fontWeight: 'bolder' }}>
                                                    {this.state?.currency}{' '}
                                                    {this.state?.bookingData?.total_booking_amount || '0'}
                                                  </td>
                                                </tr>
                                                {this.state?.refunded_amount > 0 && (
                                                  <>
                                                    <tr>
                                                      <td></td>
                                                    </tr>
                                                    <tr style={this.style.tableDataPaid}>
                                                      <td style={{ ...this.style.tableData, fontWeight: 'bolder' }}>
                                                        {'Refunded Amount'}
                                                      </td>
                                                      <td style={{ ...this.style.tableData, fontWeight: 'bolder' }}>
                                                        {this.state?.currency} {this.state?.refunded_amount || '0'}
                                                      </td>
                                                    </tr>
                                                  </>
                                                )}
                                              </>
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {localStorage.getItem('loged_In_role') === 'store' ? (
                                <div></div>
                              ) : (
                                <div
                                  className="row"
                                  style={{ marginTop: 10 }}
                                >
                                  <div
                                    className="col-2"
                                    style={{ fontWeight: 'bold' }}
                                  >
                                    Booking History
                                  </div>
                                  <div className="col-10">
                                    <div className="row">
                                      <div className="col-sm-12">
                                        <div className="table-responsive">
                                          <table className="table">
                                            <tbody>
                                              <tr
                                                className="thead-inverse"
                                                style={{ height: 40 }}
                                              >
                                                <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                  Status
                                                </th>
                                                <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                  Comments
                                                </th>
                                                <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                  Change Time
                                                </th>
                                                <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                  Change by
                                                </th>
                                              </tr>
                                              {this.state?.bookingData?.booking_statuses?.length > 0 ? (
                                                this.state?.bookingData?.booking_statuses?.map((booking) => {
                                                  return (
                                                    <tr
                                                      key={booking.id}
                                                      style={this.style.tableDataPaid}
                                                    >
                                                      <td style={this.style.tableData}>{booking.status}</td>
                                                      <td style={this.style.tableData}>{booking.comment}</td>
                                                      <td style={this.style.tableData}>
                                                        {moment(booking.created_at).format('YYYY-MM-DD HH:mm:ss')}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {booking.created_by == 1
                                                          ? 'System'
                                                          : `${booking.user?.first_name} ${booking.user?.last_name} (${booking.user?.user_type})`}
                                                      </td>
                                                    </tr>
                                                  )
                                                })
                                              ) : (
                                                <tr style={this.style.tableDataPaid}>
                                                  <td style={this.style.tableData}>{'--'}</td>
                                                  <td style={this.style.tableData}>{'--'}</td>
                                                  <td style={this.style.tableData}>{'--'}</td>
                                                  <td style={this.style.tableData}>{'--'}</td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}

                              <div
                                className="row"
                                style={{ marginTop: 10 }}
                              >
                                <div
                                  className="col-2"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  Complaint History
                                </div>
                                <div className="col-10">
                                  <div className="row">
                                    <div className="col-sm-12">
                                      <div className="table-responsive">
                                        <table className="table">
                                          <tbody>
                                            <tr
                                              className="thead-inverse"
                                              style={{ height: 40 }}
                                            >
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Title
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Description
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Status
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Action Taken
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Change Time
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Created by
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Updated by
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Action
                                              </th>
                                            </tr>
                                            {this.state?.bookingData?.complaints?.length > 0 ? (
                                              this.state?.bookingData?.complaints?.map((booking) => {
                                                return (
                                                  <tr
                                                    key={booking.id}
                                                    style={this.style.tableDataPaid}
                                                  >
                                                    <td style={this.style.tableData}>{booking.title}</td>
                                                    <td style={this.style.tableData}>{booking.description}</td>
                                                    <td style={this.style.tableData}>
                                                      <select
                                                        style={{ minWidth: 150 }}
                                                        className={`form-control`}
                                                        value={booking.status}
                                                        onChange={(e) =>
                                                          this.handleStatusChange(booking.id, e.target.value)
                                                        }
                                                      >
                                                        <option value="Open">Open</option>
                                                        <option value="In Progress">In Progress</option>
                                                        <option value="Resolved">Resolved</option>
                                                        <option value="Closed">Closed</option>
                                                      </select>
                                                    </td>
                                                    <td style={this.style.tableData}>{booking.action}</td>
                                                    <td style={this.style.tableData}>
                                                      {moment(booking.created_at)
                                                        .tz(
                                                          getCountryTimeZone(localStorage.getItem('countryShortName'))
                                                        )
                                                        .format('YYYY-MM-DD HH:mm:ss')}
                                                    </td>
                                                    <td style={this.style.tableData}>
                                                      {booking.created_user?.first_name}{' '}
                                                      {booking.created_user?.last_name}{' '}
                                                      <b>({booking.created_user?.user_type})</b>
                                                    </td>
                                                    <td style={this.style.tableData}>
                                                      {booking.updated_user?.first_name}{' '}
                                                      {booking.updated_user?.last_name}{' '}
                                                      <b>({booking.updated_user?.user_type})</b>
                                                    </td>
                                                    <td style={{ ...this.style.tableData, paddingLeft: 35 }}>
                                                      <i
                                                        className="icofont icofont-edit"
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => this.handleComplaintAction(booking.id)}
                                                      ></i>
                                                    </td>
                                                  </tr>
                                                )
                                              })
                                            ) : (
                                              <tr style={this.style.tableDataPaid}>
                                                <td style={this.style.tableData}>{'--'}</td>
                                                <td style={this.style.tableData}>{'--'}</td>
                                                <td style={this.style.tableData}>{'--'}</td>
                                                <td style={this.style.tableData}>{'--'}</td>
                                                <td style={this.style.tableData}>{'--'}</td>
                                                <td style={this.style.tableData}>{'--'}</td>
                                                <td style={this.style.tableData}>{'--'}</td>
                                                <td style={this.style.tableData}>{'--'}</td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {localStorage.getItem('loged_In_role') === 'store' ? (
                                <div></div>
                              ) : (
                                <div
                                  className="row"
                                  style={{ marginTop: 10 }}
                                >
                                  <div
                                    className="col-2"
                                    style={{ fontWeight: 'bold' }}
                                  >
                                    Add Note
                                  </div>
                                  <div className="col-8">
                                    <textarea
                                      type="text"
                                      rows={4}
                                      className="form-control"
                                      name="note"
                                      placeholder="Add Note"
                                      onChange={this.handleChange}
                                      value={this.state.note}
                                    />
                                  </div>
                                  <div
                                    className="col-2 p-l-10"
                                    style={{ fontWeight: 'bold' }}
                                  >
                                    <button
                                      onClick={() => {
                                        this.updateNote()
                                      }}
                                      className="btn btn-round btn-grd-disabled btn w-100"
                                    >
                                      Save
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                          <div
                            className="row"
                            style={{ marginTop: 10 }}
                          >
                            <div
                              className="p-20"
                              id="booking-ticket-capture"
                              // style={{ border: '1px solid #ddd', width: 450 }}
                              style={{ border: '1px solid #ddd', width: 450, display: 'none' }}
                            >
                              <div className="row p-10">
                                <div className="col-12 ticket-block">
                                  <div className="row">
                                    <div className="ticket-header">
                                      <span style={{ marginTop: 10 }}>
                                        Booking ID: {this.state.bookingData?.order_number || '--'}{' '}
                                        {this.state.bookingData?.from_flash_offer == true && (
                                          <img
                                            src={'./assets/images/ic_flash_icon.png'}
                                            alt="img"
                                            onError={(event) => {
                                              event.currentTarget.src = './assets/images/ic_flash_icon.png'
                                            }}
                                            style={{ height: 20 }}
                                          />
                                        )}
                                      </span>
                                      <img
                                        width="100"
                                        src="./assets/images/icon2.png"
                                        alt=""
                                      ></img>
                                    </div>
                                  </div>
                                  <div className="row m-t-10">
                                    <div className="col-12 text-center">
                                      <div className="cruise-name dark-blue-color">
                                        {this.state.bookingData?.chalet?.name_en || '--'}
                                      </div>
                                    </div>
                                    <div className="col-4 text-left">
                                      <div className="font-weight-bold dark-blue-color">Check-In</div>
                                      <div className="booking-day">
                                        {this.state?.bookingData?.start_date
                                          ? moment(this.state?.bookingData?.start_date, 'YYYY-MM-DD').format(
                                            'ddd, DD MMM'
                                          )
                                          : ''}
                                      </div>
                                      <div className="light-blue-color font-weight-bold text-ellipsis">Begins at</div>
                                      <div className="booking-day">
                                        {convertTo12HourFormat(this.state.bookingData?.chalet?.check_in_time)}
                                      </div>
                                    </div>

                                    <div className="col-4 text-center">
                                      <div className="m-t-20">
                                        {this.state?.cruise_img_base64 ? (
                                          <img
                                            width="100"
                                            src={this.state?.cruise_img_base64}
                                            alt=""
                                            style={{ borderRadius: 10 }}
                                            onError={(event) => {
                                              event.currentTarget.src = '/assets/images/icon.png'
                                            }}
                                          />
                                        ) : (
                                          <img
                                            width="100"
                                            src="/assets/images/icon.png"
                                            alt=""
                                            style={{ borderRadius: 10 }}
                                          />
                                        )}
                                      </div>
                                    </div>

                                    <div className="col-4 text-right">
                                      <div className="font-weight-bold dark-blue-color">Check-Out</div>
                                      <div className="booking-day">
                                        {this.state?.bookingData?.end_date
                                          ? moment(this.state?.bookingData?.end_date, 'YYYY-MM-DD').format(
                                            'ddd, DD MMM'
                                          )
                                          : ''}
                                      </div>
                                      <div className="light-blue-color font-weight-bold text-ellipsis">Ends at</div>
                                      <div className="booking-day">
                                        {convertTo12HourFormat(this.state.bookingData?.chalet?.check_out_time)}
                                      </div>
                                    </div>
                                  </div>

                                  <div className="dotted-line m-t-20 m-b-20">
                                    <div className="right-circle"></div>
                                    <div className="left-circle"></div>
                                  </div>

                                  <div className="text-center font-weight-bold dark-blue-color m-b-10">Owner</div>
                                  <div className="row">
                                    <div className="col-4 text-left">
                                      <div className="font-weight-bold light-blue-color">Name</div>
                                    </div>

                                    <div className="col-8 text-right">
                                      <div className="font-weight-bold">
                                        {this.state?.bookingData?.chalet?.owner?.first_name}{' '}
                                        {this.state?.bookingData?.chalet?.owner?.last_name}
                                      </div>
                                    </div>

                                    <div className="h-line"></div>

                                    <div className="col-4 text-left">
                                      <div className="font-weight-bold light-blue-color">Phone</div>
                                    </div>

                                    <div className="col-8 text-right">
                                      <div className="font-weight-bold">
                                        {this.state?.bookingData?.chalet?.owner?.country_code}{' '}
                                        {this.state?.bookingData?.chalet?.owner?.phone}
                                      </div>
                                    </div>
                                  </div>

                                  <div className="dotted-line m-t-40 m-b-25">
                                    <div className="right-circle"></div>
                                    <div className="left-circle"></div>
                                  </div>

                                  <div className="row">
                                    {this.state.shop_type == '' && (
                                      <>
                                        <div className="col-8 text-left">
                                          <div className="font-weight-bold light-blue-color">
                                            {this.state.bookingData?.chalet?.name_en || '--'}
                                          </div>
                                        </div>

                                        <div className="col-4 text-right">
                                          <div className="font-weight-bold">
                                            {this.state?.bookingData?.chalet_amount || '0'} {this.state?.currency}
                                          </div>
                                        </div>
                                      </>
                                    )}

                                    {this.state.shop_type != '' && (
                                      <div className="col-12 text-center">
                                        <div className="f-18 font-weight-bold text-danger">
                                          Delivery Time -{' '}
                                          {this.state?.bookingData?.start_date &&
                                            this.state.bookingData?.chalet?.check_in_time &&
                                            moment(
                                              this.state?.bookingData?.start_date +
                                              ' ' +
                                              this.state.bookingData?.chalet?.check_in_time,
                                              'YYYY-MM-DD HH:mm:ss'
                                            )
                                              .add(-30, 'minutes')
                                              .format('ddd, DD MMM hh:mm A')}
                                        </div>
                                      </div>
                                    )}

                                    {this.state?.bookingData?.diwaniya_items?.length > 0 ||
                                      this.state?.waves_market_booking?.length > 0 ||
                                      this.state?.catering_booking?.length > 0 ||
                                      this.state?.stores_booking?.length > 0 ? (
                                      <div className="col-12 text-center font-weight-bold dark-blue-color m-t-10">
                                        Waves Market
                                      </div>
                                    ) : (
                                      <></>
                                    )}
                                    {this.state.shop_type == '' &&
                                      this.state?.bookingData?.diwaniya_items?.length > 0 && (
                                        <>
                                          <div className="col-12 text-left m-t-10 m-b-10">
                                            <div className="font-weight-bold light-blue-color">Add-ons</div>
                                          </div>
                                          {[
                                            ...new Set(
                                              this.state?.bookingData?.diwaniya_items.map(
                                                (item) =>
                                                  item?.payment_status == true &&
                                                  item?.chalet_diwaniya?.category?.name_en
                                              )
                                            ),
                                          ].map((category) => (
                                            <>
                                              <div className="col-12 text-left">
                                                <div className="font-weight-bold">{category}</div>
                                              </div>
                                              {this.state?.bookingData?.diwaniya_items
                                                .filter((item) => item?.payment_status == true)
                                                .map(
                                                  (item) =>
                                                    category == item.chalet_diwaniya?.category?.name_en && (
                                                      <>
                                                        <div className="col-8 text-left">
                                                          <div className="">
                                                            {item?.chalet_diwaniya?.item_name_en || '--'} x{' '}
                                                            {item.item_qty || '--'}
                                                          </div>
                                                        </div>

                                                        <div className="col-4 text-right">
                                                          <div className="">
                                                            {item?.amount * item.item_qty + ' ' + this.state?.currency}
                                                          </div>
                                                        </div>

                                                        {item.notes && item.notes.trim() !== '' && (
                                                          <div
                                                            className="col-12 text-left"
                                                            style={{ marginTop: 5, marginBottom: 10 }}
                                                          >
                                                            <div
                                                              style={{
                                                                paddingLeft: 10,
                                                                wordWrap: 'break-word',
                                                                overflowWrap: 'break-word',
                                                                fontSize: '13px',
                                                              }}
                                                            >
                                                              <span style={{ fontWeight: 'bold' }}>Note:</span>{' '}
                                                              {item.notes}
                                                            </div>
                                                          </div>
                                                        )}
                                                        {!item.notes && <div style={{ marginBottom: 5 }}></div>}
                                                      </>
                                                    )
                                                )}
                                            </>
                                          ))}
                                        </>
                                      )}

                                    {(this.state.shop_type == 'FOOD' || this.state.shop_type == '') &&
                                      this.state?.waves_market_booking?.length > 0 && (
                                        <>
                                          <div className="h-line"></div>
                                          <div className="col-12 text-left m-t-10 m-b-10">
                                            <div className="font-weight-bold light-blue-color">Waves Market</div>
                                          </div>
                                          {this.state?.waves_market_booking
                                            .filter((item) => this.state.shop_id == '' || item.id == this.state.shop_id)
                                            .map(({ category }) => (
                                              <>
                                                <div className="col-12 text-left">
                                                  <div className="font-weight-bold">{category}</div>
                                                </div>
                                                {this.state?.bookingData?.additional_items
                                                  .filter(
                                                    (item) =>
                                                      item?.payment_status == true &&
                                                      item?.store_item?.store?.shop_name_en == category
                                                  )
                                                  .map((item) => (
                                                    <>
                                                      <div className="col-8 text-left">
                                                        <div className="">
                                                          {item?.store_item?.item_name_en || '--'}
                                                          {item?.store_item_option?.name_en && (
                                                            <span className="text-danger">{`(${item.store_item_option.name_en})`}</span>
                                                          )}{' '}
                                                          x {item.item_qty || '--'} x {item.item_qty || '--'}
                                                        </div>
                                                      </div>

                                                      <div className="col-4 text-right">
                                                        <div className="">
                                                          {item?.amount * item.item_qty + ' ' + this.state?.currency}
                                                        </div>
                                                      </div>

                                                      {item.notes && item.notes.trim() !== '' && (
                                                        <div
                                                          className="col-12 text-left"
                                                          style={{ marginTop: 5, marginBottom: 10 }}
                                                        >
                                                          <div
                                                            style={{
                                                              paddingLeft: 10,
                                                              wordWrap: 'break-word',
                                                              overflowWrap: 'break-word',
                                                              fontSize: '13px',
                                                            }}
                                                          >
                                                            <span style={{ fontWeight: 'bold' }}>Note:</span>{' '}
                                                            {item.notes}
                                                          </div>
                                                        </div>
                                                      )}
                                                      {!item.notes && <div style={{ marginBottom: 5 }}></div>}
                                                    </>
                                                  ))}
                                              </>
                                            ))}
                                        </>
                                      )}

                                    {(this.state.shop_type == 'STORE' || this.state.shop_type == '') &&
                                      this.state?.stores_booking?.length > 0 && (
                                        <>
                                          <div className="h-line"></div>
                                          <div className="col-12 text-left m-t-10 m-b-10">
                                            <div className="font-weight-bold light-blue-color">Stores</div>
                                          </div>
                                          {this.state?.stores_booking
                                            .filter((item) => this.state.shop_id == '' || item.id == this.state.shop_id)
                                            .map(({ category }) => (
                                              <>
                                                <div className="col-12 text-left">
                                                  <div className="font-weight-bold">{category}</div>
                                                </div>
                                                {this.state?.bookingData?.additional_items
                                                  .filter(
                                                    (item) =>
                                                      item?.payment_status == true &&
                                                      item?.store_item?.store?.shop_name_en == category
                                                  )
                                                  .map((item) => (
                                                    <>
                                                      <div className="col-8 text-left">
                                                        <div className="">
                                                          {item?.store_item?.item_name_en || '--'}
                                                          {item?.store_item_option?.name_en && (
                                                            <span className="text-danger">{`(${item.store_item_option.name_en})`}</span>
                                                          )}{' '}
                                                          x {item.item_qty || '--'}
                                                        </div>
                                                      </div>

                                                      <div className="col-4 text-right">
                                                        <div className="">
                                                          {item?.amount * item.item_qty + ' ' + this.state?.currency}
                                                        </div>
                                                      </div>

                                                      {item.notes && item.notes.trim() !== '' && (
                                                        <div
                                                          className="col-12 text-left"
                                                          style={{ marginTop: 5, marginBottom: 10 }}
                                                        >
                                                          <div
                                                            style={{
                                                              paddingLeft: 10,
                                                              wordWrap: 'break-word',
                                                              overflowWrap: 'break-word',
                                                              fontSize: '13px',
                                                            }}
                                                          >
                                                            <span style={{ fontWeight: 'bold' }}>Note:</span>{' '}
                                                            {item.notes}
                                                          </div>
                                                        </div>
                                                      )}
                                                      {!item.notes && <div style={{ marginBottom: 5 }}></div>}
                                                    </>
                                                  ))}
                                              </>
                                            ))}
                                        </>
                                      )}

                                    {(this.state.shop_type == 'CATERING' || this.state.shop_type == '') &&
                                      this.state?.catering_booking?.length > 0 && (
                                        <>
                                          <div className="h-line"></div>
                                          <div className="col-12 text-left m-t-10 m-b-10">
                                            <div className="font-weight-bold light-blue-color">Catering</div>
                                          </div>
                                          {this.state?.catering_booking
                                            .filter((item) => this.state.shop_id == '' || item.id == this.state.shop_id)
                                            .map(({ category }) => (
                                              <div
                                                key={category}
                                                className="col-12 text-left"
                                              >
                                                <div className="font-weight-bold">{category}</div>
                                                {this.state?.bookingData?.additional_items
                                                  .filter(
                                                    (item) =>
                                                      item?.payment_status &&
                                                      item?.store_item?.store?.shop_name_en === category
                                                  )
                                                  .map((item) => (
                                                    <div
                                                      key={item?.store_item?.item_name_en}
                                                      className="row"
                                                    >
                                                      <div className="col-8 text-left">
                                                        <div>
                                                          {item?.store_item?.item_name_en || '--'} x{' '}
                                                          {item.item_qty || '--'}
                                                        </div>
                                                        {/* <div>
                                                          'Delivery Time - '
                                                          {item?.delivery_date + ' ' + item?.delivery_time}
                                                        </div> */}
                                                      </div>
                                                      <div className="col-4 text-right">
                                                        <div>{item?.amount + ' ' + this.state?.currency}</div>
                                                      </div>

                                                      {item.catering_items
                                                        ?.sort((a, b) => a.is_addon - b.is_addon)
                                                        .map((ele) => (
                                                          <div
                                                            key={ele?.store_catering_item?.name_en}
                                                            className="col-12"
                                                          >
                                                            <div className="row">
                                                              <div className="col-1 text-left p-r-0">
                                                                <div>{'-'}</div>
                                                              </div>
                                                              <div className="col-9 text-left p-0 fs-12">
                                                                <div>
                                                                  {ele?.store_catering_item?.name_en || '--'} x{' '}
                                                                  {ele.item_qty || '--'}
                                                                </div>
                                                              </div>
                                                              <div className="col-2 text-right p-l-0">
                                                                {ele.is_addon && (
                                                                  <div>
                                                                    {(ele.is_addon ? ele?.amount : 0) * ele.item_qty +
                                                                      ' ' +
                                                                      this.state?.currency}
                                                                  </div>
                                                                )}
                                                              </div>
                                                            </div>
                                                          </div>
                                                        ))}

                                                      {item.notes && item.notes.trim() !== '' && (
                                                        <div
                                                          className="col-12 text-left"
                                                          style={{ marginTop: 5, marginBottom: 10 }}
                                                        >
                                                          <div
                                                            style={{
                                                              paddingLeft: 10,
                                                              wordWrap: 'break-word',
                                                              overflowWrap: 'break-word',
                                                              fontSize: '13px',
                                                            }}
                                                          >
                                                            <span style={{ fontWeight: 'bold' }}>Note:</span>{' '}
                                                            {item.notes}
                                                          </div>
                                                        </div>
                                                      )}
                                                      {!item.notes && <div style={{ marginBottom: 5 }}></div>}
                                                    </div>
                                                  ))}
                                              </div>
                                            ))}
                                        </>
                                      )}

                                    {/* {
                                      this.state?.bookingData?.bulkCoupon?.coupon_type == 'drink' && <>
                                        <div className="h-line"></div>
                                        <div className="col-8 text-left">
                                          <div className="">
                                            Free Drinks x {this.state?.bookingData?.bulkCoupon?.no_of_drinks || 0}
                                          </div>
                                        </div>

                                        <div className="col-4 text-right">
                                          <div className="">
                                            {'0'} {this.state?.currency}
                                          </div>
                                        </div>
                                      </>
                                    } */}

                                    {/* If downloading store ticket */}
                                    {this.state.shop_type != '' && (
                                      <>
                                        {this.state?.shop_delivary_amount > 0 && (
                                          <>
                                            <div className="h-line"></div>
                                            <div className="col-8 text-left">
                                              <div className="">Delivery Charges</div>
                                            </div>

                                            <div className="col-4 text-right">
                                              <div className="">
                                                {this.state?.shop_delivary_amount || '0'} {this.state?.currency}
                                              </div>
                                            </div>
                                          </>
                                        )}
                                        {this.state?.shop_vat_amount > 0 && (
                                          <>
                                            <div className="h-line"></div>
                                            <div className="col-8 text-left">
                                              <div className="">Vat</div>
                                            </div>

                                            <div className="col-4 text-right">
                                              <div className="">
                                                {this.state?.shop_vat_amount || '0'} {this.state?.currency}
                                              </div>
                                            </div>
                                          </>
                                        )}
                                        <div className="h-line"></div>
                                        <div className="col-8 text-left">
                                          <div className="font-weight-bold light-blue-color">Total Amount</div>
                                        </div>
                                        <div className="col-4 text-right">
                                          <div className="font-weight-bold">
                                            {this.state.shop_total_amount || 0} {this.state?.currency}
                                          </div>
                                        </div>
                                      </>
                                    )}
                                    {/* If downloading full ticket */}
                                    {this.state.shop_type == '' && (
                                      <>
                                        {this.state?.delivery_total_price > 0 && (
                                          <>
                                            <div className="h-line"></div>
                                            <div className="col-8 text-left">
                                              <div className="">Delivery Charges</div>
                                            </div>

                                            <div className="col-4 text-right">
                                              <div className="">
                                                {this.state?.delivery_total_price || '0'} {this.state?.currency}
                                              </div>
                                            </div>
                                          </>
                                        )}
                                        {(this.state?.bookingData?.vat_amount > 0 || this.state?.vat_amount > 0) && (
                                          <>
                                            <div className="h-line"></div>
                                            <div className="col-8 text-left">
                                              <div className="">Vat ({getVat(this.state.country)}%)</div>
                                            </div>

                                            <div className="col-4 text-right">
                                              <div className="">
                                                {this.state?.bookingData?.vat_amount || this.state?.vat_amount || '0'}{' '}
                                                {this.state?.currency}
                                              </div>
                                            </div>
                                          </>
                                        )}
                                        {this.state?.bookingData?.coupon_applied_amount > 0 && (
                                          <>
                                            <div className="h-line"></div>
                                            <div className="col-8 text-left">
                                              <div className="">Coupon Amount</div>
                                            </div>

                                            <div className="col-4 text-right">
                                              <div className="">
                                                -{this.state?.bookingData?.coupon_applied_amount || '0'}{' '}
                                                {this.state?.currency}
                                              </div>
                                            </div>
                                          </>
                                        )}
                                        {this.state?.bookingData?.wallet_applied_amount > 0 && (
                                          <>
                                            <div className="h-line"></div>
                                            <div className="col-8 text-left">
                                              <div className="">Wallet Amount Applied</div>
                                            </div>

                                            <div className="col-4 text-right">
                                              <div className="">
                                                -{this.state?.bookingData?.wallet_applied_amount || '0'}{' '}
                                                {this.state?.currency}
                                              </div>
                                            </div>
                                          </>
                                        )}
                                        <div className="h-line"></div>
                                        {this.state.bookingData.extra_payment > 0 && (
                                          <>
                                            <div className="col-8 text-left">
                                              <div className="font-weight-bold light-blue-color">Extra Payment</div>
                                            </div>
                                            <div className="col-4 text-right">
                                              <div className="font-weight-bold">
                                                {this.state.bookingData.extra_payment || 0} {this.state?.currency}
                                              </div>
                                            </div>
                                          </>
                                        )}
                                        <div className="col-8 text-left">
                                          <div className="font-weight-bold light-blue-color">Total Amount</div>
                                        </div>
                                        <div className="col-4 text-right">
                                          <div className="font-weight-bold">
                                            {this.state?.bookingData?.total_booking_amount || '0'}{' '}
                                            {this.state?.currency}
                                          </div>
                                        </div>
                                      </>
                                    )}
                                  </div>

                                  <div className="dotted-line m-t-40 m-b-20 dark-blue-color">
                                    <div className="right-circle"></div>
                                    <div className="left-circle"></div>
                                  </div>

                                  <div className="row text-center">
                                    <div className="col-12">
                                      <div className="font-weight-bold dark-blue-color">
                                        Booking Pass: {this.state.bookingData?.order_number || '--'}
                                      </div>
                                      <div className="dark-blue-color">
                                        Issue Date:{' '}
                                        {this.state?.bookingData?.createdAt ? (
                                          <Moment format="DD MMM YYYY">{this.state?.bookingData?.createdAt}</Moment>
                                        ) : (
                                          '--'
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <h6>Details not found</h6>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ChaletBookingDetail
